import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
export const FAQSection = () => {
  const faqs = [{
    q: '¿Es seguro?',
    a: 'Totalmente. Es un proceso energético sin efectos secundarios nocivos. No se ingieren medicamentos ni ninguna sustancia.'
  }, {
    q: '¿Es algo esotérico o religioso?',
    a: 'Para nada. Es un método práctico basado en herramientas energéticas y neurociencia aplicada. La Física Cuántica explica cómo es posible que sucedan estas transformaciones.'
  }, {
    q: '¿Funciona a distancia?',
    a: 'Sí, perfectamente. La energía y la información cuántica no conocen de distancias físicas. Puedes encontrarte en cualquier lugar del mundo y los efectos beneficiosos serán iguales.'
  }, {
    q: '¿Cuántas sesiones necesito?',
    a: 'Depende del objetivo, pero lo que diferencia al Método Integra es la rapidez; generalmente con una sesión ya es suficiente.'
  }, {
    q: '¿Funciona también con animales y plantas?',
    a: 'Sí, es muy efectivo logrando resultados asombrosos. También para Empresas, Proyectos y Emprendimientos que quieren lograr sus objetivos.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section id="faq" className="py-24 bg-soft/30" data-id="element-25">
      <div className="container mx-auto px-6 max-w-3xl" data-id="element-26">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-27">
          <h2 className="text-4xl md:text-5xl font-bold text-primary mb-4" data-id="element-28">
            Preguntas Frecuentes
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-29">
          {faqs.map((faq, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: idx * 0.1
        }} className="bg-white rounded-2xl overflow-hidden shadow-sm border border-soft/50" data-id="element-30">
              <button onClick={() => setOpenIndex(openIndex === idx ? null : idx)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-31">
                <span className="text-lg font-bold text-primary" data-id="element-32">{faq.q}</span>
                <ChevronDownIcon className={`w-6 h-6 text-accent transition-transform duration-300 flex-shrink-0 ml-4 ${openIndex === idx ? 'rotate-180' : ''}`} data-id="element-33" />
              </button>

              <AnimatePresence data-id="element-34">
                {openIndex === idx && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-35">
                    <div className="px-6 pb-6 text-primary/80 leading-relaxed" data-id="element-36">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
};